export const STATUS_STYLE = {
  pending: { label: "Pending", cls: "text-gray-300 border-white/15 bg-white/5" },
  processing: { label: "Processing", cls: "text-sky-300 border-sky-500/40 bg-sky-500/10 animate-pulse" },
  needs_review: { label: "Needs Review", cls: "text-amber-300 border-amber-500/40 bg-amber-500/10" },
  approved: { label: "Approved", cls: "text-emerald-300 border-emerald-500/40 bg-emerald-500/10" },
  rejected: { label: "Rejected", cls: "text-rose-300 border-rose-500/40 bg-rose-500/10" },
  failed: { label: "Failed", cls: "text-rose-300 border-rose-500/50 bg-rose-500/15" },
  exception: { label: "Exception", cls: "text-purple-300 border-purple-500/40 bg-purple-500/10" },
  duplicate: { label: "Duplicate", cls: "text-gray-400 border-white/15 bg-white/5" },
  superseded: { label: "Superseded", cls: "text-gray-500 border-white/10 bg-transparent line-through" },
  withdrawn: { label: "Withdrawn", cls: "text-gray-500 border-white/10 bg-transparent" },
  unapproved: { label: "Unapproved", cls: "text-amber-300 border-amber-500/40 bg-amber-500/10" },
  reviewed: { label: "Reviewed", cls: "text-emerald-300 border-emerald-500/40 bg-emerald-500/10" },
};

export function StatusBadge({ status, testId }) {
  const s = STATUS_STYLE[status] || { label: status || "—", cls: "text-gray-400 border-white/10" };
  return (
    <span className={`inline-flex items-center text-[9px] font-mono font-bold uppercase tracking-wide border px-1.5 py-0.5 rounded whitespace-nowrap ${s.cls}`} data-testid={testId}>
      {s.label}
    </span>
  );
}

export function PageCite({ page, quote, onOpen, testId }) {
  if (!page) return <span className="text-[10px] font-mono text-gray-500">no page cite</span>;
  return (
    <button
      onClick={() => onOpen(page, quote)}
      data-testid={testId}
      title={quote ? `"${quote}"` : `Open page ${page}`}
      className="text-[10px] font-mono font-bold text-[#2dd4bf] border border-[#2dd4bf]/30 rounded px-1.5 py-0.5 hover:bg-[#2dd4bf]/10 transition-colors duration-200 whitespace-nowrap"
    >
      p.{page}
    </button>
  );
}

export const money = (n) => (typeof n === "number" ? n.toLocaleString("en-US", { style: "currency", currency: "USD" }) : "—");
